// extracted by mini-css-extract-plugin
export var closed = "_hb-1";
export var resizer = "_hb-0";